export default {
    Country: 5,
    Province: 10,
  District: 15,
};
